export default "__VITE_ASSET__sh$6kPyG__"